import React, { useEffect, useState } from "react";
import Profile from "./Profile";
import PasswordChange from "./PasswordChange";

import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

import WebUtils from "../../utils/WebUtils";
import Utils from "../../utils/Utils";
import { profileGetApi } from "../../api/candidate";
import Loader from "../Loader";

const userDetail = Utils.getUserDetail();

function ProfileMain(props) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  const getProfileData = () => {
    const url = `${profileGetApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setData(result.data.data);
          // console.log(result.data.data);
          // setCountryCode(result.data.data.countryCode);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const updateData = (newData) => {
    if (newData) {
      getProfileData();
      props.setuserDataChanged(props.userDataChanged + 1);
    }
  };

  useEffect(() => {
    getProfileData();
  }, []);

  return (
    <>
      {loading && <Loader />}
      {data?.firstName && (
        <div>
          <Profile data={data} loading={loading} updateData={updateData} />
          <PasswordChange />
        </div>
      )}
    </>
  );
}

export default ProfileMain;
